var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.showModalVisualizaPdf
        ? _c("app-modal-visualiza-pdf", {
            attrs: {
              titulo: _vm.tituloModal,
              tipo: _vm.tipoModal,
              isImagem: _vm.isImagem,
              conteudo: _vm.conteudoModal,
              conteudoSemId: _vm.conteudoModalSemid,
              isVTN: false
            },
            on: { closeModal: _vm.closeModalVisualizaPdf }
          })
        : _vm._e(),
      _c("app-divider", {
        attrs: { label: _vm.titulo, tooltip: _vm.informacao }
      }),
      _c(
        "el-row",
        [
          _c("app-upload-documentos", {
            attrs: {
              id: _vm.idUploadDocumento,
              target: _vm.urlUpload,
              fileType: _vm.validExtensions,
              tiposDocumentos: _vm.getTiposDocumentos,
              pecasTecnicas: _vm.pecasTecnicas,
              maxSize: _vm.maxSize,
              aba: _vm.aba,
              required:
                _vm.tiposDocumentosObrigatorios &&
                _vm.tiposDocumentosObrigatorios.length > 0,
              documentos: _vm.documentos,
              mensagemErroFilaPlantaMemorial: _vm.mensagemErroFilaPlantaMemorial
            },
            on: {
              mudaTipo: _vm.mudaTipo,
              anexar: _vm.anexar,
              setDadosPlanilha: _vm.setDadosPlanilha
            },
            model: {
              value: _vm.documentoSelecionado,
              callback: function($$v) {
                _vm.documentoSelecionado = $$v
              },
              expression: "documentoSelecionado"
            }
          })
        ],
        1
      ),
      _c(
        "el-row",
        [
          _c("validation-provider", {
            attrs: {
              rules: _vm.requireDocumentosObrigatorios(),
              name: _vm.aba + "/Documentos"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var errors = ref.errors
                  return [
                    _c(
                      "div",
                      {
                        staticClass: "input",
                        class: { "erro box-error": errors.length }
                      },
                      [
                        _c(
                          "el-table",
                          {
                            attrs: { data: _vm.documentos },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return [
                                      _c("el-table-column", {
                                        attrs: {
                                          formatter: _vm.labelDescricao,
                                          label: "Tipo de documento:",
                                          align: "left"
                                        }
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          formatter: _vm.labelAnexo,
                                          label: "Anexos"
                                        }
                                      }),
                                      _c("el-table-column", {
                                        attrs: {
                                          label: "Ações",
                                          align: "center",
                                          width: "80"
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function(scope) {
                                                return [
                                                  _vm.isEstadoMA
                                                    ? _c("app-action-button", {
                                                        attrs: {
                                                          disabled: !_vm.isDocumentoParaVisualizacao(
                                                            scope.row
                                                          ),
                                                          cor: !_vm.isDocumentoParaVisualizacao(
                                                            scope.row
                                                          )
                                                            ? "#C0C4CC"
                                                            : "#666666",
                                                          icone: "eye",
                                                          text: !_vm.isDocumentoParaVisualizacao(
                                                            scope.row
                                                          )
                                                            ? "Não é possível exibir esse arquivo"
                                                            : "Visualizar",
                                                          fontSize: "18"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.abrirDocumento(
                                                              scope.row
                                                            )
                                                          }
                                                        }
                                                      })
                                                    : _vm._e(),
                                                  _vm.showDownloadDocumentos
                                                    ? _c("app-action-button", {
                                                        attrs: {
                                                          icone: "download",
                                                          cor: "#666666",
                                                          text:
                                                            "Baixar Documento"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.getDownload(
                                                              scope.row
                                                            )
                                                          }
                                                        }
                                                      })
                                                    : _vm._e(),
                                                  _c("app-action-button", {
                                                    attrs: {
                                                      icone: "times",
                                                      cor: "#CF0021",
                                                      text: "Remover documento"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.deleteRow(
                                                          scope.row,
                                                          scope.$index
                                                        )
                                                      }
                                                    }
                                                  })
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          true
                                        )
                                      })
                                    ]
                                  }
                                }
                              ],
                              null,
                              true
                            ),
                            model: {
                              value: _vm.validationValues,
                              callback: function($$v) {
                                _vm.validationValues = $$v
                              },
                              expression: "validationValues"
                            }
                          },
                          [
                            _c(
                              "div",
                              { attrs: { slot: "empty" }, slot: "empty" },
                              [
                                _c("span", [
                                  _vm._v(
                                    'Nenhum arquivo adicionado. Para adicionar um novo arquivo, selecione-o e clique no botão "Anexar".'
                                  )
                                ])
                              ]
                            )
                          ]
                        )
                      ],
                      1
                    ),
                    _c("span", { staticClass: "help erro" }, [
                      _vm._v(_vm._s(errors[0]))
                    ])
                  ]
                }
              }
            ])
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-10aeea80", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10aeea80","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/central/components/cadastro/AppDocumentosRetificacao.vue
// module id = null
// module chunks = 